import React from "react";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";

import style from "./style";
import BannerButtons from "./BannerButtons";
import BannerSearch from "../BannerSearch";
import FloatingSignUp from "../FloatingSignUp";

export default class Banner extends React.Component {
  render() {
    return (
      <div style={{ flexGrow: 1, width: '100%' }}>
        <FloatingSignUp />
        <Grid
          className={this.props.type === "landing"
            ? 'landing-banner'
            : this.props.type === "diner"
              ? 'diner-banner'
              : 'chef-banner'}
        >
          <Grid item xs={12} className="banner-grid">
            <div className="mbl-show">
              {this.props.type === "landing" && (
                <Typography variant="h4" style={style.bannerText} gutterBottom>
                  The perfect home dining experience is just a click away.
                </Typography>
              )}
              {this.props.type === "diner" && (
                <Typography variant="h4" style={style.bannerText} gutterBottom>
                  Experience Great Food at Home With Our In-Home Cooking Service
                </Typography>
              )}
              {this.props.type === "chef" && (
                <Typography data-test-id={"earnby"} variant="h4" style={style.bannerText} gutterBottom>
                  Chefs needed<br /> for bringing 5-star dinning experiences!
                </Typography>
              )}
              {this.props.type !== "home" && this.props.type !== "chef" && (
                <span className="mbl-home-cook" style={style.bannerSubText}>
                  Meals Made From Scratch Created by Local Personal Chefs.
                </span>
              )}
              {this.props.type === "chef" && (
                <span style={style.bannerSubText}>
                    Are you a talented chef committed to bringing fine dining to your clients' homes?<br />Find out how Cuisine Crafters can help you grow your business.
                  </span>
              )}

              {this.props.type === "home" && (
                <Typography variant="h4" style={style.bannerText} gutterBottom>
                  Welcome to Cuisine Crafters<sup>&#174;</sup>
                </Typography>
              )}
            </div>
            <Hidden xsDown>
              <Grid item>
                {this.props.type === "landing" && (
                  <Typography
                    variant="h3"
                    style={style.bannerText}
                    gutterBottom
                  >
                    The perfect home dining experience
                    <br />
                    is just a click away.
                  </Typography>
                )}
                {this.props.type === "diner" && (
                  <Typography
                    variant="h3"
                    style={style.bannerText}
                    gutterBottom
                  >
                    Experience Great Food at Home<br />With Our In-Home Cooking Service
                  </Typography>
                )}
                {this.props.type === "chef" && (
                  <Typography
                   data-test-id={"earnby"}
                    variant="h3"
                    style={style.bannerText}
                    gutterBottom
                  >
                    Chefs needed<br /> for bringing 5-star dinning experiences!
                  </Typography>
                )}
                {this.props.type !== "home" && this.props.type !== "chef" && (
                  <span style={style.bannerSubText}>
                    Meals Made From Scratch Created by Local Personal Chefs.
                  </span>
                )}
                {this.props.type === "chef" && (
                  <span style={style.bannerSubText}>
                    Are you a talented chef committed to bringing fine dining to your clients' homes?<br />Find out how Cuisine Crafters can help you grow your business.
                  </span>
                )}

                {this.props.type === "home" && (
                  <div style={{ display: 'flex' }}>
                    <Typography
                      variant="h3"
                      style={style.bannerText}
                      gutterBottom
                    >
                      Welcome to Cuisine Crafters
                    </Typography>
                    <Typography
                      variant="p"
                      style={style.bannerTextR}
                      gutterBottom
                    >
                      <sup>&#174;</sup>
                    </Typography>
                  </div>
                )}
              </Grid>
            </Hidden>

            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ marginTop: 56, }}
            >
              {this.props.type !== "home" && (
                <BannerButtons
                  history={this.props.history}
                  type={this.props.type}
                />
              )}
              {this.props.type === "home" && <BannerSearch {...this.props} />}
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}
